const KINDS = {
  all: { label: 'All' },
  library: { label: 'Libraries' },
  template: { label: 'Templates' },
  integration: { label: 'Integrations' },
  registrar: { label: 'Domain Registrars' },
  plugin: { label: 'Plugins' }
}

export const MarketplaceSidebar = {
  flow: 'y',
  gap: 'A',
  padding: 'A',
  width: 'F',
  minWidth: 'F',

  CaptionTitle: {
    Text: {
      text: 'Browse'
    }
  },

  KindList: {
    flow: 'y',
    gap: 'X',
    childExtends: 'MarketplaceKindItem',
    children: KINDS
  },

  // User-curated pins — surface above recents since they're
  // intentional favorites. Hidden when no pins yet. Caption gets a
  // count + Clear button, parity with RecentCaption.
  PinnedCaption: {
    flow: 'x',
    align: 'center space-between',
    hide: (el) => {
      const host = el.call('marketplaceHostOf', el)
      return !(host?.pinnedIds?.length)
    },

    Text: {
      tag: 'span',
      text: (el) => {
        const host = el.call('marketplaceHostOf', el)
        const n = host?.pinnedIds?.length || 0
        return `Pinned (${n})`
      },
      fontSize: 'Y',
      color: 'caption',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    PinnedClearBtn: {
      extends: 'Button',
      text: 'Clear',
      title: 'Clear every pinned item',
      fontSize: 'X',
      padding: 'X Y',
      background: 'transparent',
      color: 'caption',
      onClick: (e, el) => {
        const host = el.call('marketplaceHostOf', el)
        el.call('clearPinned', host)
      }
    }
  },

  PinnedList: {
    flow: 'y',
    gap: 'X',
    hide: (el) => {
      const host = el.call('marketplaceHostOf', el)
      return !(host?.pinnedIds?.length)
    },
    children: (el) => {
      const host = el.call('marketplaceHostOf', el)
      const ids = host?.pinnedIds || []
      const catalog = host?.catalog || []
      const byId = new Map(catalog.map((i) => [i.id, i]))
      return ids.map((id) => byId.get(id)).filter(Boolean)
    },
    // Reuse MarketplaceRecentItem — same compact logo+name shape.
    childExtends: 'MarketplaceRecentItem'
  },

  // Recently-viewed: up to 8 items. Hidden when the list is empty
  // (first session + no drills yet) so the sidebar doesn't show an
  // empty stub. Children fn resolves `host.recentIds` against the
  // catalog so the row has the full item shape.
  RecentCaption: {
    flow: 'x',
    align: 'center space-between',
    hide: (el) => {
      const host = el.call('marketplaceHostOf', el)
      return !(host?.recentIds?.length)
    },

    Text: {
      tag: 'span',
      text: 'Recently viewed',
      fontSize: 'Y',
      color: 'caption',
      textTransform: 'uppercase',
      letterSpacing: 'X'
    },

    // Wipe the list in one click. Discoverable affordance — users
    // know what "Clear" means in this caption.
    RecentClearBtn: {
      extends: 'Button',
      text: 'Clear',
      title: 'Clear the recently-viewed list',
      fontSize: 'X',
      padding: 'X Y',
      background: 'transparent',
      color: 'caption',
      onClick: (e, el) => {
        const host = el.call('marketplaceHostOf', el)
        el.call('clearRecent', host)
      }
    }
  },

  RecentList: {
    flow: 'y',
    gap: 'X',
    hide: (el) => {
      const host = el.call('marketplaceHostOf', el)
      return !(host?.recentIds?.length)
    },
    children: (el) => {
      const host = el.call('marketplaceHostOf', el)
      const ids = host?.recentIds || []
      const catalog = host?.catalog || []
      const byId = new Map(catalog.map((i) => [i.id, i]))
      return ids.map((id) => byId.get(id)).filter(Boolean)
    },
    childExtends: 'MarketplaceRecentItem'
  }
}
